import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.states(['company.sharing-center.shared-passwords.manage-bulk','company.sharing-center.shared-authenticators.manage-bulk'], {
        url: '/manage/bulk',
        params: {selectedAccounts: []},
		views: {
            '@company.sharing-center': 'companySharingCenterManageBulkAccounts'
        },
        resolve: {
			companyId,
			selectedAccounts
        },
    });
}
/** @ngInject */
function selectedAccounts($stateParams) {
    return $stateParams.selectedAccounts;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/manage-bulk/manage-bulk.state.js